<svg width="96" height="96" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
  <defs>
<radialGradient id="paint0_radial_5481_122513" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(85.5714 63.1124) rotate(90) scale(138.607)">
<stop offset="0.0885417" stop-color="#EB1000"/>
<stop offset="1" stop-color="#EB1000" stop-opacity="0"/>
</radialGradient>
<linearGradient id="paint1_linear_5481_122513" x1="69.4617" y1="-3.08825" x2="13.8656" y2="68.9935" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF4885"/>
<stop offset="1" stop-color="#FF4885" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint2_linear_5481_122513" x1="35.5898" y1="-36.2716" x2="46.3146" y2="32.3671" gradientUnits="userSpaceOnUse">
<stop offset="0.15625" stop-color="#7A6AFD"/>
<stop offset="1" stop-color="#7A6AFD" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint3_linear_5481_122513" x1="-88.1609" y1="101.725" x2="92.2907" y2="66.0615" gradientUnits="userSpaceOnUse">
<stop stop-color="#30A7FE" stop-opacity="0"/>
<stop offset="0.432292" stop-color="#30A7FE" stop-opacity="0.994652"/>
<stop offset="0.609375" stop-color="#30A7FE"/>
<stop offset="1" stop-color="#30A7FE" stop-opacity="0"/>
</linearGradient>
<clipPath id="clip0_5481_122513">
<rect width="96" height="96" rx="10" fill="white"/>
</clipPath>
</defs>
<clipPath id="mask0_5481_122513">
<path d="M75.0659 33.3259C76.923 34.8454 78 37.1181 78 39.5176V69.9993C78 74.4175 74.4183 77.9993 70 77.9993H58.0002V56C58.0002 52.6863 55.3139 50 52.0002 50H44C40.6863 50 38 52.6863 38 56V77.9993H26C21.5817 77.9993 18 74.4176 18 69.9993V39.5176C18 37.1181 19.077 34.8454 20.9341 33.3259L42.9342 15.3259C45.8811 12.9148 50.1191 12.9148 53.066 15.3259L75.0659 33.3259Z" fill="#292929"/>
</clipPath>
<g clip-path="url(#mask0_5481_122513)">
<g clip-path="url(#clip0_5481_122513)">
<rect width="96" height="96" rx="10" fill="#D9F4FD"/>
<circle cx="85.5714" cy="63.1124" r="138.607" fill="url(#paint0_radial_5481_122513)"/>
<path d="M-8.63919 30.067C-10.18 -3.11477 15.4702 -31.263 48.652 -32.8037C81.8337 -34.3445 109.982 -8.69438 111.523 24.4874C113.063 57.6692 87.4133 85.8174 54.2316 87.3582C21.0498 88.8989 -7.09842 63.2488 -8.63919 30.067Z" fill="url(#paint1_linear_5481_122513)"/>
<path d="M24.2526 -66.43C16.7672 -71.0619 7.28331 -71.0903 -0.22988 -66.5032L-75.3753 -20.6218C-82.7348 -16.1282 -82.7471 -5.52169 -75.3976 -1.01111L-0.748691 44.8052C6.75324 49.4089 16.2372 49.4034 23.7327 44.7888L98.2278 -1.0704C105.538 -5.57135 105.552 -16.1186 98.2501 -20.6366L24.2526 -66.43Z" fill="url(#paint2_linear_5481_122513)"/>
<path d="M-47.8586 45.9177C-32.3701 45.9177 -18.3401 52.1863 -8.18231 62.2992C12.1334 82.5597 28.9763 82.577 49.2919 62.3512C59.4498 52.1863 73.4971 45.9004 89.003 45.9004C119.997 45.9177 145.105 70.9575 145.105 101.868C145.105 132.778 119.997 157.8 89.003 157.8C73.4624 157.8 59.415 151.497 49.2572 141.332C28.9589 121.141 12.1334 121.158 -8.18231 141.419C-18.3401 151.549 -32.3701 157.8 -47.8586 157.8C-78.8357 157.8 -103.944 132.761 -103.944 101.868C-103.944 70.9749 -78.8357 45.9177 -47.8586 45.9177Z" fill="url(#paint3_linear_5481_122513)"/>
</g>
</g>

</svg>
